import React from 'react';
import { Button, Col, Row } from 'antd';
import loadable from '@loadable/component';
import { connect } from 'react-redux';
import { getData, getWebPImagePath } from '../utils';
import { addOrRemoveFromWishList, addToCart } from '../reducer';
import WishListButton from './WishListButton';
import Spinner from './Spinner';

import '../css/FeaturedArea.less';

const ReactPlayer = loadable(() => import('react-player/youtube'));
const ProductGallery = loadable(
    () => import(/* webpackChunkName: "ProductGallery" */ './ProductGallery')
);
let Slider = null;

class FeaturedArea extends React.Component {
    constructor(props) {
        super(props);
        this.getData = getData.bind(this);

        this.state = {
            content: null,
            loading: true,
            minWidth: 1000,
            minWidthWrapper: 1200,
            productsOnWishList: [],
            productIdsOnWishList: null,
            mobile: false,
            wrapperResize: false,
            contentLoaded: false,
        };
    }

    componentDidMount() {
        if (this.props.url) {
            (async () => {
                let content = await this.getData(this.props.url, this.props.body);
                if (content.r && content.r.totalSetSize !== 0) {
                    content.r.contents.forEach((oneItem) => {
                        //Get video ID if it is an URL
                        if (oneItem.custom1.includes('https://'))
                            oneItem.custom1 = /[^/]*$/.exec(oneItem.custom1);
                    });
                    const contents = content.r.contents.sort(this.sortFeaturedAreas);
                    this.setState({ content: contents });
                    this.componentDidUpdate();
                } else {
                    this.setState({ loading: false });
                }
            })();
        }

        if (this.props.browserWidth <= this.state.minWidth && !this.state.mobile) {
            this.setState({ mobile: true });
        }

        if (this.props.browserWidth <= this.state.minWidthWrapper && !this.state.wrapperResize) {
            this.setState({ wrapperResize: true });
        }

        if (this.props.content && this.props.content !== this.state.content) {
            this.setState({ content: this.props.content });
        }

        if (this.props.slider) Slider = loadable(() => import('./CustomSlick'));
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps !== this.props && this.state.content != null) {
            let productsOnWishList = [];
            this.state.content.forEach((content) => {
                if (this.props.productIdsOnWishList.includes(content.objectId))
                    productsOnWishList.push(content.objectId);
            });
            this.setState({ productsOnWishList: productsOnWishList });
        }

        if (this.props.browserWidth <= this.state.minWidth && !this.state.mobile) {
            this.setState({ mobile: true });
        }

        if (this.props.browserWidth > this.state.minWidth && this.state.mobile) {
            this.setState({ mobile: false });
        }

        if (this.props.browserWidth <= this.state.minWidthWrapper && !this.state.wrapperResize) {
            this.setState({ wrapperResize: true });
        }

        if (this.props.browserWidth > this.state.minWidthWrapper && this.state.wrapperResize) {
            this.setState({ wrapperResize: false });
        }

        if (this.props.content && this.props.content !== this.state.content) {
            this.setState({ content: this.props.content });
        }
    }

    sortFeaturedAreas = (a, b) => {
        let aSortValue = new Date(a.dateFrom);
        let bSortValue = new Date(b.dateFrom);
        if (!aSortValue && !bSortValue) return 0;
        if (!aSortValue) return 1;
        if (!bSortValue) return -1;
        return bSortValue.getTime() - aSortValue.getTime();
    };

    updateWishList = (e, id) => {
        this.props.dispatch(addOrRemoveFromWishList(e, id));
    };

    addToCart = (id) => {
        this.props.dispatch(addToCart(id, 1));
    };

    renderLeft = (content) => {
        return (
            <div className={'content-wrapper-left'}>
                <Row>
                    {this.state.mobile ? (
                        ''
                    ) : (
                        <Col
                            span={12}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                transform: 'translateY(-50%)',
                            }}
                        >
                            {this.getContent(content)}
                        </Col>
                    )}

                    <Col span={this.state.mobile ? 24 : 12} style={{ marginLeft: 'auto' }}>
                        {content.custom1
                            ? this.state.mobile
                                ? this.getReactPlayer('react-player-right', content)
                                : this.getReactPlayer('react-player-left', content)
                            : this.getImage(content, 'featured-image right')}
                        {this.state.mobile ? this.getContent(content) : ''}
                    </Col>
                </Row>
            </div>
        );
    };

    renderRight = (content) => {
        return (
            <div className={'content-wrapper-right'}>
                <Row>
                    <Col span={this.state.mobile ? 24 : 12}>
                        {content.custom1
                            ? this.getReactPlayer('react-player-right', content)
                            : this.getImage(content, 'featured-image')}
                        {this.state.mobile ? this.getContent(content) : ''}
                    </Col>
                    {this.state.mobile ? (
                        ''
                    ) : (
                        <Col
                            span={12}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                right: 0,
                            }}
                        >
                            {this.getContent(content, 'featured-image')}
                        </Col>
                    )}
                </Row>
            </div>
        );
    };

    appendSize = (imagePath, browserWidth, isBanner) => {
        let size = 'big';
        if (isBanner) {
            if (browserWidth < 500) size = 'small';
            else if (browserWidth < 1400) size = 'medium';
        } else {
            if (browserWidth < 1000) {
                if (browserWidth < 400) size = 'small';
                else if (browserWidth < 600) size = 'medium';
            } else {
                //Image takes up ~half of the screen
                let imageWidth = browserWidth / 2;
                if (imageWidth < 400) size = 'small';
                else if (imageWidth < 600) size = 'medium';
            }
        }
        let extension = imagePath.substring(imagePath.lastIndexOf('.'), imagePath.length);
        let imageName = imagePath.substring(0, imagePath.lastIndexOf('.'));
        return imageName + '-' + size + extension;
    };

    getImage = (content, className) => {
        let imageName = content.description.name1;
        if (content.description.name2 && this.state.mobile) imageName = content.description.name2;
        let imagePath = window.imageBase + '/content/' + imageName;
        let webpPath = getWebPImagePath(imagePath);
        return (
            <picture>
                <source
                    type="image/webp"
                    srcSet={this.appendSize(webpPath, this.props.browserWidth)}
                />
                <source srcSet={this.appendSize(imagePath, this.props.browserWidth)} />
                <img
                    className={className}
                    src={imagePath}
                    alt={content.description.title}
                    loading="lazy"
                    decoding="async"
                    onLoad={this.onContentLoaded}
                    onError={this.onContentLoaded}
                />
            </picture>
        );
    };

    getContent = (content) => {
        if (this.state.contentLoaded) {
            return (
                <div
                    className={
                        this.state.wrapperResize ? 'content-wrapper-phone' : 'content-wrapper'
                    }
                >
                    <h3 className={'content-header'}>{content.description.custom1}</h3>
                    <h1
                        className={'content-title'}
                        dangerouslySetInnerHTML={{ __html: content.description.title }}
                    />
                    <div
                        className={'content-body'}
                        dangerouslySetInnerHTML={{ __html: content.description.content }}
                    />
                    {content.objectId > 0 ? (
                        <div className={'cart-buttons'}>
                            <Button
                                onClick={() => this.addToCart(content.objectId)}
                                className={'origo-button'}
                                style={{
                                    color: content.description.custom3,
                                    background: content.description.custom4,
                                }}
                            >
                                {content.description.custom2}
                            </Button>
                            <WishListButton
                                updateWishList={this.updateWishList}
                                id={content.objectId}
                                isOnWishList={this.state.productsOnWishList.includes(
                                    content.objectId
                                )}
                                className={'wishList-featured'}
                            />
                        </div>
                    ) : (
                        content.description.custom2 && (
                            <Button
                                href={content.clickUrl}
                                className={'origo-button'}
                                style={{
                                    color: content.description.custom3,
                                    background: content.description.custom4,
                                }}
                            >
                                {content.description.custom2}
                            </Button>
                        )
                    )}
                </div>
            );
        }
    };

    getReactPlayer = (className, content) => {
        if (!this.state.contentLoaded && this.state.mobile) this.onContentLoaded();
        return (
            <div className={'player-wrapper ' + className}>
                <ReactPlayer
                    onReady={this.onContentLoaded}
                    className={'react-player'}
                    light={
                        this.state.mobile
                            ? 'https://img.youtube.com/vi/' + content.custom1 + '/hqdefault.jpg'
                            : false
                    }
                    url={'https://www.youtube.com/watch?v=' + content.custom1}
                    width={this.state.mobile ? '100%' : '90%'}
                    height={this.state.mobile ? '100%' : '90%'}
                    config={{
                        youtube: {
                            embedOptions: {
                                host: 'https://www.youtube-nocookie.com',
                            },
                            playerVars: {
                                hl: 'is',
                                modestbranding: '1',
                            },
                        },
                    }}
                    controls
                />
            </div>
        );
    };

    onContentLoaded = () => {
        this.setState({ contentLoaded: true });
    };

    getOverlayStyle = (content) => {
        let overlayStyle;
        if (this.props.browserWidth < 480 && content.custom4) {
            overlayStyle = content.custom4;
        } else if (this.props.browserWidth < 880 && content.custom3) {
            overlayStyle = content.custom3;
        } else if (this.props.browserWidth < 1500 && content.custom2) {
            overlayStyle = content.custom2;
        } else if (content.custom1) {
            overlayStyle = content.custom1;
        }
        return overlayStyle ? JSON.parse(overlayStyle) : null;
    };

    getBanner = (content) => {
        const overlayStyle = this.getOverlayStyle(content);
        let imagePath = content.description.name1;
        if (this.props.browserWidth < 880 && content.description.name2) {
            imagePath = content.description.name2;
        }
        imagePath = window.imageBase + '/content/' + imagePath;
        let webpPath = getWebPImagePath(imagePath);
        const target =
            content.clickUrl.includes('tolvutek.is') || content.clickUrl.startsWith('/')
                ? '_self'
                : '_blank';

        return (
            <div className={'featured-banner'}>
                <picture>
                    <source
                        type="image/webp"
                        srcSet={this.appendSize(webpPath, this.props.browserWidth, true)}
                    />
                    <source srcSet={this.appendSize(imagePath, this.props.browserWidth, true)} />
                    <img
                        className={'featured-banner-image'}
                        src={imagePath}
                        alt={content.description.title}
                        loading="lazy"
                        decoding="async"
                        onLoad={this.onContentLoaded}
                        onError={this.onContentLoaded}
                    />
                </picture>
                {!this.props.noOverlay && this.state.contentLoaded ? (
                    <div id="banner-overlay" style={overlayStyle}>
                        <h2 dangerouslySetInnerHTML={{ __html: content.description.title }} />
                        <p dangerouslySetInnerHTML={{ __html: content.description.content }} />
                        {content.description.custom2 && content.clickUrl ? (
                            <Button
                                href={content.clickUrl}
                                target={target}
                                className={'origo-button'}
                                style={{
                                    color: content.description.custom3,
                                    background: content.description.custom4,
                                }}
                            >
                                {content.description.custom2}
                            </Button>
                        ) : (
                            ''
                        )}
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    };

    render() {
        if (this.state.content) {
            let areas = [];
            this.state.content.forEach((content) => {
                switch (content.contentTypeId) {
                    case 1:
                    case 41:
                        if (content.clickUrl) {
                            const target =
                                content.clickUrl.includes('tolvutek.is') ||
                                content.clickUrl.startsWith('/')
                                    ? '_self'
                                    : '_blank';
                            areas.push(
                                <a href={content.clickUrl} target={target}>
                                    <div className={'featured-area'}>{this.getBanner(content)}</div>
                                </a>
                            );
                        } else {
                            areas.push(
                                <div className={'featured-area'}>{this.getBanner(content)}</div>
                            );
                        }
                        return;
                    case 42:
                    case 35:
                    case 36:
                        content.custom2 === 'left' || this.props.galleryAlign === 'left'
                            ? areas.push(
                                  <div className={'featured-area'}>{this.renderLeft(content)}</div>
                              )
                            : areas.push(
                                  <div className={'featured-area'}>{this.renderRight(content)}</div>
                              );
                        return;
                    case 119:
                        const url = content.description.custom4;
                        areas.push(
                            <ProductGallery
                                url={url ? url : 'FetchProducts'}
                                body={JSON.parse(content.description.content)}
                                showAllUrl={content.clickUrl}
                                heading={content.description.title}
                                centered
                                store={this.props.store}
                            />
                        );
                        return;
                    default:
                        return;
                }
            });
            if (this.props.slider) {
                let settings = {
                    dots: areas.length < 10,
                    accessibility: true,
                    infinite: areas.length > 1,
                    speed: 500,
                    cssEase: 'ease-in-out',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipe: true,
                    swipeToSlide: true,
                    touchThreshold: 5,
                    arrows: false,
                    centerPadding: '50px',
                    afterChange: this.afterChange,
                    lazyLoad: 'progressive',
                    autoplay: true,
                    autoplaySpeed: 5000,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    pauseOnDotsHover: true,
                    initialSlide: window.topBannerIndex
                        ? window.topBannerIndex
                        : Math.floor(Math.random() * areas.length),
                };
                return <Slider {...settings}>{areas}</Slider>;
            } else {
                return <div>{areas}</div>;
            }
        } else if (this.state.loading && !this.props.noSpinner) {
            return (
                <div className={'product-gallery-spinner'}>
                    <Spinner className={'center-spinner'} size={120} />
                </div>
            );
        } else return null;
    }
}

const mapStateToProps = (state) => {
    return {
        productIdsOnWishList: state.wishList.productIds,
        browserWidth: state.browserWidth,
    };
};

export default connect(mapStateToProps, null)(FeaturedArea);
